import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import PaymentQrLayer from '../components/school/PaymentQrLayer'

const PaymentQrPage = () => {
  return (
    <MasterLayout>

        <PaymentQrLayer/>
    </MasterLayout>

  )
}

export default PaymentQrPage
